/**
 * ITPR023507 - EPIC SSO project - Mar 2018 release - SP 12292017
 * Updated model to capture Dual HBS and Care team indicator
 */
'use strict';
angular.module('cvsApp').factory('patientInfoModel',['commonModel',function(CM) {	
	
	var patientInfoModel = function(){

		var self = this;

		var apiResponse = {};
		var header = {};

		this.setResponse = function(data){
			CM.setAGPResponse(data, 'getPatientInformationResponse');
		}

        this.setHeader = function(){
            header = CM.getHeader();
        }

		this.getResponse = function(){
			apiResponse = CM.getResponse();
			header = CM.getHeader();
			return self;		
		}

		this.showView = function(){
			if(apiResponse.isViewError){	
				return !apiResponse.isViewError;
			}
			return true;
		}

		this.getError = function(){
			if(apiResponse.showError){
				return apiResponse.showError;
			}
			return '';

		}		

		var getHeader = function () {
			return header;
		}

		this.getPatientPrimaryAddress = function(addressType){
			
			if(!apiResponse.showError){
				var data = apiResponse.patientProfile.patientsAddresses.patientsAddress;
			
					if(_.isArray(data)){
						for(var items in data){
							if(data[items].addressType == addressType){
								return data[items];								
							}
						}
					}else{
						if(data.addressType==addressType){
							return data;
						}
					}
				return {};
			}			
		}

		this.getFirstAddress = function(){			
			if(!apiResponse.showError){
				var data = apiResponse.patientProfile.patientsAddresses.patientsAddress;
			
					if(_.isArray(data)){												
						return data[0];
					}else{					
						return data;						
					}
				return {};
			}			
		}

		this.getPatientAllAddress = function(){			
			if(!apiResponse.showError){
				var data = apiResponse.patientProfile.patientsAddresses.patientsAddress;
			
					if(_.isArray(data)){
						return data;												
						
					}else{	
						var address = [];
						address.push(data);
						return address;						
					}
				
			}			
		}

		this.getBrandingInfos = function () {
			if (!apiResponse.showError) {
				if (apiResponse.patientProfile.hasOwnProperty("brandingInfos")) {
					var data = apiResponse.patientProfile.brandingInfos;
					if (_.isArray(data)) {
						return data;
					}
				} else {
					return '';
				}
			} else {
				return '';
			}
		}

		this.getFirstPhoneNo = function(){			
			if(!apiResponse.showError){
				var data = apiResponse.patientProfile.phones;
			
					if(_.isArray(data)){												
						return data[0];
					}else{					
						return data;						
					}
				return {};
			}			
		}
        /**
         * ITPR023507 - EPIC SSO project - Mar 2018 release - SP 12292017
         * Updated model to capture Dual HBS and Care team indicator
         */
		this.getPatientInfo = function () {
			if (!apiResponse.showError) {
				var data = apiResponse.patientProfile;

				return {
					firstName: data.firstName ? data.firstName : '',
					lastName: data.lastName ? data.lastName : '',
					dateOfBirth: data.dateOfBirth ? data.dateOfBirth : '',
					gender: data.gender ? data.gender : '',
					phones: data.phones,
					benefitPlan: data.benefitPlan ? data.benefitPlan : '',
					patientAccordantStatus: data.patientAccordantStatus ? data.patientAccordantStatus : '',
					memberStatus: data.memberStatus ? data.memberStatus : false,
					patientsMedicalConditions: data.patientsMedicalConditions,
					catsOnlyPatient: data.catsPatientOnly,
					medicareIndicator: data.medicareIndicator,
					eppInd: data.eppInd,
					emailAddress: data.emailAddress,
					address: data.patientsAddresses,
					messagePreferenceInfo: data.messagePreferenceInfo,
					aobFormStatus: data.aobFormStatus,
					hippaFormStatus: data.hippaFormStatus,
					dualHBSIndicator: (data.hasOwnProperty('dualHBSIndicator') && data.dualHBSIndicator === "true"),
					careTeamIndicator: (data.hasOwnProperty('careTeamPatientIndicator') && data.careTeamPatientIndicator === "true"),
					refId: getHeader().refId,
					sourceSystem: data.sourceSystem
				};
			}

		}
	
	}
	
	return new patientInfoModel();
}]);